export enum OrganisationType {
  SERVICE_DELIVERY = 'SERVICE_DELIVERY',
  CERTIFICATION = 'CERTIFICATION',
  INSPECTION = 'INSPECTION',
  ACCREDITATION = 'ACCREDITATION',
  STANDARDISATION = 'STANDARDISATION',
}

export type ThresholdUnit = 'day' | 'week' | 'month' | 'year';

export interface ClientDTO {
  id: number;
  name: string;
  allowEditCustomers: boolean;
  allowEditResources: boolean;
  requireMfaForAllUsers?: boolean;
  enableAiAgent?: boolean;
  enableTravelBlockers?: boolean;
  ssoRequired?: boolean;
  useGoogleRoutesForTravelDistances?: boolean;
  enableFragmentedBookings?: boolean;
  enablePreRequestAutomation: boolean;
  preRequestThreshold: number;
  preRequestThresholdUnit: ThresholdUnit;
  enableRequestAutomation: boolean;
  requestThreshold: number;
  requestThresholdUnit: ThresholdUnit;
}
